<template>
  <form @submit.stop.prevent="search">
    <div class="search-input el-input">
      <input v-model.lazy="searchInputValue" @change="changeHandler" :placeholder="placeholder" type="text" autocomplete="off" class="el-input__inner">
    </div>
    <button class="search-button">
      <i class="iconfont icon-fangdajing"></i>
    </button>
  </form>
</template>
<script>
export default {
  name: "DsfDataGridSearchInput",
  props: {
    placeholder: {
      type: String,
      default: ""
    },
    defaultSearchValue: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      searchInputValue:""
    };
  },
  computed: {},
  watch: {
    defaultSearchValue: {
      handler(to) {
        this.searchInputValue = to;
      },
      immediate: true
    }
  },
  // beforeCreate() {},
  created() {},
  // beforeMount() {},
  mounted() {},
  // beforeDestroy() {},
  // destroyed() {},
  methods: {
    search() {
      this.$emit("change", this.searchInputValue);
      this.$emit("search", this.searchInputValue);
    },
    changeHandler() {
      this.$emit("change", this.searchInputValue);
    }
  }
};
</script>